import axios from "src/api/axiosInstance";
var postChangePasswordRequest = function (email) {
    return axios.post('/change_password_requests', JSON.stringify({
        userEmail: email
    }));
};
var postForgotPasswordChangeByHash = function (hash, password, confirmPassword) {
    return axios.post('/user_password_change/forgot_password', JSON.stringify({
        changePasswordRequestHash: hash,
        password: password,
        confirmPassword: confirmPassword
    }));
};
export { postChangePasswordRequest, postForgotPasswordChangeByHash, };
